import { Component, input, output } from '@angular/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatMenuModule } from '@angular/material/menu'

import { TaskBoard, TaskBoardType } from '@ziptility/graphql'
import { IconsModule } from '@ziptility/icons'
import { UserAvatarComponent } from '../../components/user-avatar/user-avatar.component'

@Component({
  selector: 'task-list-actions',
  template: `
    <div
      class="banner selection-banner bg-blue-brand text-white rounded flex flex-row items-center justify-between p-3 border-gray-200 border-t"
    >
      <div class="h-full px-3 flex items-center text-center justify-center">{{ selections().length }}</div>
      <div class="icon cursor-pointer " [mat-menu-trigger-for]="boardMenu" matTooltip="Board">
        <i-feather name="user" class="feather-icon-sm"></i-feather>
        <div>Change board</div>
      </div>
      <div class="icon cursor-pointer " [mat-menu-trigger-for]="dueDateMenu" matTooltip="Due Date">
        <i-feather name="calendar" class="feather-icon-sm"></i-feather>
        <div>Change due date</div>
      </div>
      <div class="icon cursor-pointer " (click)="onDeleteSelected.emit()" matTooltip="Delete">
        <i-feather name="trash" class="feather-icon-sm"></i-feather>
        <div>Delete</div>
      </div>
    </div>

    <mat-menu #boardMenu>
      <div class="bv-menu p-3 max-h-[500px] overflow-auto">
        @for (board of boards(); track board) {
          <div class="menu-item" (click)="onBoardChange.emit({ board: board })">
            <div class="flex items-center">
              @if (board.type === TaskBoardType.User) {
                <user-avatar [fullName]="board.name" displayStyle="full"></user-avatar>
              }
              @if (board.type === TaskBoardType.TaskList) {
                <div class="ml-2">
                  {{ board.name }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </mat-menu>
    <mat-menu #dueDateMenu>
      <mat-calendar (selectedChange)="onDueDateSelected.emit({ dueDate: $event })"></mat-calendar>
      <div class="flex items-center justify-center">
        <div
          class="cursor-pointer text-inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-brand"
          (click)="onDueDateSelected.emit({ dueDate: undefined })"
        >
          None
        </div>
      </div>
    </mat-menu>
  `,
  styles: [
    `
      .icon {
        padding: theme('spacing.2') theme('spacing.3');
        border-radius: theme('borderRadius.md');
        display: flex;
        align-items: center;
        justify-content: center;
        gap: theme('spacing.2');
        font-size: theme('fontSize.xs');
      }
    `,
  ],
  imports: [IconsModule, MatMenuModule, MatDatepickerModule, UserAvatarComponent],
})
export class TaskListActionsComponent {
  TaskBoardType = TaskBoardType

  selections = input<string[]>([])
  boards = input<TaskBoard[]>([])
  onBoardChange = output<{ board: TaskBoard }>()
  onDueDateSelected = output<{ dueDate: string }>()
  onDeleteSelected = output<void>()
}
